import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cx from "classnames";
import { Text } from "@cinch-labs/design-system";
import styles from "./find-vehicle-results-count.module.css";
import skeletonStyles from "./skeleton.module.css";
const FindVehicleResultsCount = ({ searchResultsCount , pageItemsRange , fetchStatus  }, ref)=>{
    const isLoading = fetchStatus;
    const { start , end  } = pageItemsRange;
    const startCount = start.toLocaleString();
    const endCount = end.toLocaleString();
    const resultsCount = searchResultsCount.toLocaleString();
    const setResultsText = ()=>{
        if (searchResultsCount === 0) {
            return null;
        }
        if (searchResultsCount === 1) {
            return "1 result";
        }
        return `${startCount} to ${endCount} of ${resultsCount} results`;
    };
    return /*#__PURE__*/ _jsx(Text, {
        element: "span",
        fontSizeFixed: "m",
        className: cx(styles["findVehicleResults"], {
            [skeletonStyles["inline"]]: isLoading,
            [skeletonStyles["skeleton"]]: isLoading
        }),
        id: "results-count",
        "aria-live": "polite",
        "data-testid": "results-count",
        children: /*#__PURE__*/ _jsx("span", {
            ref: ref,
            children: setResultsText()
        })
    });
};
export default /*#__PURE__*/ forwardRef(FindVehicleResultsCount);
